import { array, object, string } from 'yup'

export const addContributionPointsValidationSchema = object().shape({
  sport: object().nullable().required('Sport is required'),
  property: object().nullable().required('Property is required'),
  tournament: object().nullable(),
  fields: array(string().required('Field is required')).min(1, 'At least one field is required')
})
